class Accounts {
    static roundOffAmount(amount) {
        return Math.abs(amount) < 0.01 ? 0.00 : amount.toFixed(2)
    }
}

export default Accounts